export const calculateAutoDismissTime = message_length => Math.max(Math.min(message_length * 50, 10000), 5000) || 5000;